import { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import type { PDFDocumentProxy } from 'pdfjs-dist';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { CLottie } from 'components/atoms';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

type PDFFile = string | File | null;
type Props = { file: PDFFile };

export default function PDFViewer({ file }: Props) {
  const [numPages, setNumPages] = useState<number>();

  function onDocumentLoadSuccess({ numPages: nextNumPages }: PDFDocumentProxy) {
    setNumPages(nextNumPages);
  }

  return (
    <div className="flex flex-1 items-center justify-center">
      <Document file={file} onLoadSuccess={onDocumentLoadSuccess} loading={<CLottie isFullPage />}>
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            // NOTE: scale breaks pdf rendering on iPhones https://github.com/wojtekmaj/react-pdf/issues/1149
          />
        ))}
      </Document>
    </div>
  );
}

